/**
 * Room-to-limit gauge (SPEC §17.7 Home): the binding constraint as an arc, coloured by risk
 * status. `fraction` is room ÷ limit (1 = untouched, 0 = breached); `null` = no data.
 */
export function RoomGauge({
  fraction,
  status,
  label,
  value,
}: {
  fraction: number | null;
  status: "ok" | "warn" | "danger" | "locked" | "none";
  label: string;
  value: string;
}): React.JSX.Element {
  const r = 54;
  const c = Math.PI * r; // half circle
  const f = fraction === null ? 0 : Math.min(Math.max(fraction, 0), 1);
  const color =
    status === "danger" || status === "locked"
      ? "var(--danger)"
      : status === "warn"
        ? "var(--warn)"
        : status === "ok"
          ? "var(--buy)"
          : "var(--text-3)";
  return (
    <div className="gauge">
      <svg viewBox="0 0 140 80" width="100%" role="img" aria-label={`${label}: ${value}`}>
        <path
          d="M 16 70 A 54 54 0 0 1 124 70"
          fill="none"
          stroke="var(--bg-3)"
          strokeWidth="10"
          strokeLinecap="round"
        />
        <path
          d="M 16 70 A 54 54 0 0 1 124 70"
          fill="none"
          stroke={color}
          strokeWidth="10"
          strokeLinecap="round"
          strokeDasharray={`${String(c * f)} ${String(c)}`}
        />
        <text x="70" y="58" textAnchor="middle" className="gauge-value">
          {value}
        </text>
        <text x="70" y="76" textAnchor="middle" className="gauge-label">
          {label}
        </text>
      </svg>
    </div>
  );
}
